import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Invoice } from '../../models/invoice/invoice.model';
import { Registration } from '../../models/training/registration.model';
import { ExchangeApiService } from '../exchange-api.service';

@Injectable()
export class RegistrationService {

  path = 'registrations';

  constructor(
    private exchangeApiService: ExchangeApiService,
  ) {
  }

  getInvoice(registrationId: string): Observable<Invoice> {
    return this.exchangeApiService
      .get(`${this.path}/${registrationId}/invoice`)
      .pipe(
        map(data => new Invoice(data)),
      );
  }

  create(instanceId: string, memberUuid: string): Observable<Registration> {
    let params = new HttpParams();
    params = params.append('memberUuid[]', memberUuid);

    let url = `course_instances/${instanceId}/registrations?`;
    url += params.toString();

    return this.exchangeApiService.post(url)
      .pipe(
        map(registrations => registrations[0]),
        map(registration => new Registration(registration)),
      );
  }
}
